import { render, staticRenderFns } from "./mapLabel.vue?vue&type=template&id=ef1d9a2a&scoped=true"
import script from "./mapLabel.vue?vue&type=script&lang=js"
export * from "./mapLabel.vue?vue&type=script&lang=js"
import style0 from "./mapLabel.vue?vue&type=style&index=0&id=ef1d9a2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1d9a2a",
  null
  
)

export default component.exports